import * as React from "react";
import type { PageContext } from "vike/types";
import { ContextPage } from "./usePageContext";

export function PageContextProvider({
  pageContext,
  children,
}: {
  pageContext: PageContext;
  children: React.ReactNode;
}) {
  return (
    <ContextPage.Provider value={pageContext}>{children}</ContextPage.Provider>
  );
}
